/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { bool, func, number } from 'prop-types';
import {
	Form, Input, Select
} from 'antd';
import { validateMessages } from '../../utils/validateMessages';
import { layoutNewForm } from '../../utils/utils';
import { FormButtons } from '../../components';
const { Option } = Select;

const NewSupervisorForm = ({ onSubmit, onCancel, isLoading }) => (
	<Form {...layoutNewForm} onFinish={onSubmit}
		labelCol={{ span: 12, offset: 0 }}
		wrapperCol={{ span: 24 }}
		layout={"vertical"}
		validateMessages={validateMessages} 
		name="nest-messages">
		<Form.Item
			name={['name']}
			label="Nombre"
			rules={[
				{
					required: true
				}
			]}
		>
			<Input />
		</Form.Item>
		<Form.Item
			name={['lastName']}
			label="Apellido"
			rules={[
				{
					required: true
				}
			]}
		>
			<Input />
		</Form.Item>
		<Form.Item
			name={['email']}
			label="Email"
			rules={[
				{
					required: true,
					type: 'email'
				}
			]}
		>
			<Input />
		</Form.Item>
		<Form.Item
			name={['internalIdentifier']}
			label="Cod. interno"
			dependencies={['internalIdentifier']}
			rules={[
				{
					required: true,
				},
				({ getFieldValue }) => ({
					validator(_, value) {
						if (!value) {
							return Promise.resolve();
						}

						if (getFieldValue('internalIdentifier').length < 3) {
							return Promise.reject(new Error('El Cod. interno debe tener 3 digitos'));
						}
						return Promise.resolve();


					},
				})
			]}
		>
			<Input />
		</Form.Item>
		<Form.Item
			name={['dni']}
			label="DNI"
			rules={[
				{
					required: true,
				}]}
		>
			<Input style={{
				width: '100%',
			}} />
		</Form.Item>
		<Form.Item
			name="category"
			label="Categoría"
			rules={[
				{
					required: true,
				},
			]}
		>
			<Select >
				<Option value="INICIAL">Inicial</Option>
				<Option value="PLENO">Pleno</Option>
			</Select>
		</Form.Item>
		<Form.Item
			name={['password']}
			label="Contraseña temporal"
			rules={[
				{
					required: true,
				}
			]}
		>
			<Input />
		</Form.Item>
		<Form.Item
			name={['passwordConfirmation']}
			label="Confirme su contraseña"
			dependencies={['password']}
			rules={[
				{
					required: true,
					message: 'Confirme su contraseña, por favor',
				},
				({ getFieldValue }) => ({
					validator(_, value) {
						if (!value || getFieldValue('password') === value) {
							return Promise.resolve();
						}
						return Promise.reject(new Error('Las contraseñas deben coincidir'));
					},

				}),
			]}
		>
			<Input />
		</Form.Item>
		<FormButtons isLoading={isLoading} onCancel={onCancel} />
	</Form>
);

NewSupervisorForm.propTypes = {
	onSubmit: func.isRequired,
	onCancel: func.isRequired,
	isLoading: bool
};

NewSupervisorForm.defaultProps = {
	isLoading: false
};

export default NewSupervisorForm;
